// @ts-nocheck
import * as actions from './windowActions';

export { actions };
